import React from "react";

import { Filter, useTranslate, ReferenceArrayInput } from "react-admin";

import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";

import { DateTimeInput, NumberInputEx } from "../../../components/inputs";
import TerminalDatesInput from "../../../components/inputs/TerminalDatesInput";

import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { ScannerLogContextType } from "entities/ScannerLogContextType";

const defaultSort = { field: "first_name", order: "DESC" };

export const ScannerLogsFilter = (props) => {
	const translate = useTranslate();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const terminalId = globalFilters?.terminal_id?.[0];

	return (
		<Filter {...props}>
			<TextInputEx source="scanned_text" />
			<TextInputEx source="scanner_name" />
			<SelectEnumInput
				source="context_type"
				enumObj={ScannerLogContextType}
				enumName="scanner_log_context_type"
				resettable
			/>
			<NumberInputEx source="context_id" />
			<ReferenceArrayInput
				source="scanned_by"
				reference="users"
				sort={defaultSort}
				filter={{ no_range: true }}
			>
				<AutocompleteArrayInputEx optionText="full_name" debounce={500} resettable />
			</ReferenceArrayInput>
			<TerminalDatesInput
				component={DateTimeInput}
				source="scanned_at:gte"
				label={translate("osfc.filters.scanned_at.from")}
				priorityRecord={{ terminal_id: terminalId }}
			/>
			<TerminalDatesInput
				component={DateTimeInput}
				source="scanned_at:lte"
				label={translate("osfc.filters.scanned_at.to")}
				priorityRecord={{ terminal_id: terminalId }}
			/>
		</Filter>
	);
};
